import { get, post } from 'api/client';
import config from 'config';

type ReviewStatusResponse = {
  review_exists: boolean;
};

type FormDisplayedResponse = {
  form_displayed_at: string | null;
  form_display_count: number;
};

const G2Api = {
  getReviewStatus(): Promise<ReviewStatusResponse> {
    return get<ReviewStatusResponse>('/g2/review-status', {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  getFormDisplayed(): Promise<FormDisplayedResponse> {
    return get<FormDisplayedResponse>('/g2/form-displayed', {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  formDisplayed(): Promise<FormDisplayedResponse> {
    return post('/g2/form-displayed', null, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  getReviewFormUrl(): Promise<{ url: string }> {
    return get<{ url: string }>('/g2/review-form-url', {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },
};

export default G2Api;
